import styled from "styled-components";

import { setFontVariant, colorsPalettes, $robotoFontFamily } from "@similarweb/styles";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { Content, Footer, GeneralButton, Header, ModalContent, Title } from "../common.styled";
import EmailInput from "../EmailInput/EmailInput";
import EmailsList from "../EmailsList";

const RequestInviteText = styled.span`
    margin: 16px 0;
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    font-family: ${$robotoFontFamily};
`;

const InviteTeamMatesScreen = ({
    onClose,
    onSendInvites,
    isLoading = false,
    remainingSeatsCount,
    remainingSeatsTotal,
    isUnlimitedSeats = false,
    allowedDomains = [],
    selectedEmails = [],
    onRemoveEmail,
    handleAddEmail,
}: {
    onClose: () => void;
    onSendInvites: (emails: string[]) => void;
    isLoading?: boolean;
    remainingSeatsCount: number;
    remainingSeatsTotal: number;
    isUnlimitedSeats?: boolean;
    allowedDomains: string[];
    selectedEmails?: string[];
    onRemoveEmail: (email: string) => void;
    handleAddEmail: (email: string) => void;
}) => {
    const translate = useTranslation();

    return (
        <ModalContent>
            <Header>
                <Title>{translate("growth.homepage.inviteUsersV2.modal.invite.title")}</Title>
            </Header>
            <Content>
                <RequestInviteText>
                    {translate("growth.homepage.inviteUsersV2.modal.invite.RequestInviteText")}
                </RequestInviteText>
                <EmailInput
                    allowedDomains={allowedDomains}
                    remainingSeatsCount={remainingSeatsCount}
                    remainingSeatsTotal={remainingSeatsTotal}
                    isUnlimitedSeats={isUnlimitedSeats}
                    isLoading={isLoading}
                    handleAddEmail={handleAddEmail}
                />
                <EmailsList
                    emails={selectedEmails}
                    onRemoveEmail={onRemoveEmail}
                />
            </Content>
            <Footer
                flex
                gap={"8px"}
                justifyContent="flex-end"
            >
                <GeneralButton
                    type="flat"
                    onClick={onClose}
                >
                    {translate("growth.homepage.inviteUsersV2.modal.invite.btn_cancel")}
                </GeneralButton>
                <GeneralButton
                    type="primary"
                    onClick={() => {
                        onSendInvites(selectedEmails);
                    }}
                    isDisabled={!selectedEmails.length || isLoading}
                >
                    {translate("growth.homepage.inviteUsersV2.modal.invite.btn_send")}
                </GeneralButton>
            </Footer>
        </ModalContent>
    );
};

export default InviteTeamMatesScreen;
